<form #f="ngForm" (ngSubmit)="f.form.valid && createOrEditGroupDocument()">
    <mat-card>
        <mat-card-header>
            <mat-card-title class="mat-card-title-custom" *ngIf="!documents.id">
                <span>{{'service_type.add_service_type' | translate}}</span>
            </mat-card-title>
            <mat-card-title class="mat-card-title-custom" *ngIf="documents.id">
                <span>{{'service_type.edit_service_type' | translate}}</span>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content class="mb-3 mat-card-content-contract-sm">
            <!--Thông tin loại hợp đồng-->
            <mat-accordion>
                <mat-expansion-panel expanded="true" class="mt-3">
                    <mat-panel-title class="mat-panel-title mt-3 d-flex justify-content-between align-items-center">
                        <span>{{'service_type.contract_type_info' | translate}}</span>
                        <small style="position: absolute; right:30px" class="form-text text-gray pull-right">
                            (<span style="color: red;">*</span>) {{'form.info' | translate}}
                        </small>
                    </mat-panel-title>
                    <ng-container *ngIf="documents.id && documents.type == 2;else addOrDocDefault">
                        <div class="row pt-3 pb-3">
                            <!-- Mã loại hợp đồng -->
                            <div class="col-6 d-flex">
                                <label class="col-sm-3 col-form-label">{{'search_form.service_type_code' |
                                    translate}}</label>
                                <label class="col-sm-9 col-form-label font-weight-bold">
                                    {{documents.code}}
                                </label>
                            </div>
                            <!-- Tên loại hợp đồng-->
                            <div class="col-6 d-flex">
                                <label class="col-sm-3 col-form-label">{{'search_form.service_type_name' |
                                    translate}}</label>
                                <label class="col-sm-9 col-form-label font-weight-bold">
                                    {{documents.name}}
                                </label>
                            </div>
                           <!--Check box hợp đồng lao động-->
                           <div class="col-6 d-flex align-items-center" *ngIf="entType === '1' && isApplyContractMoha">
                            <input type="checkbox" name="checkbox_contract" class="custom-checkbox me-5"
                                style="width: 16px; height: 16px;"
                                [(ngModel)]="documents.isEmploymentContract" (click)="offAllowCheckSign();"
                                [disabled]="documents.id" id="checkbox_contract">
                            <label style="margin-left: 10px; font-size: 14px; font-weight: 400;"
                                for="checkbox_contract" class="mb-0">{{'search_form.checkbox_contact' |
                                translate}} </label>
                            </div>

                          <!-- Loai HDLD -->
                          <div class="col-6" *ngIf="entType === '1' && isApplyContractMoha">
                            <mat-form-field class="w-50 group_mysign">
                              <mat-label>{{'search_form.service_type_contract' | translate}}
                              </mat-label>
                              <mat-select [(value)]="selectedContract"
                                          (selectionChange)="onContractChange($event)"
                                          [disabled]="!documents.isEmploymentContract || documents.id">
                                <mat-option *ngFor="let contract of listContract"
                                            [value]="contract.value">
                                  {{ contract.viewValue | translate }}
                                </mat-option>
                              </mat-select>

                            </mat-form-field>
                            <mat-error *ngIf="documents.isEmploymentContract && !selectedContract">
                              {{'validation.not_select_contract' | translate}}
                            </mat-error>
                          </div>
                          <!-- Ghi chú -->
                            <div class="col-6 d-flex">
                                <label class="col-sm-3 col-form-label">{{'search_form.note' | translate}}</label>
                                <label class="col-sm-9 col-form-label font-weight-bold">
                                    {{documents.note}}
                                </label>
                            </div>
                        </div>
                    </ng-container>
                    <ng-template #addOrDocDefault>
                        <div class="row pt-3 pb-3">
                            <!-- Mã loại hợp đồng -->
                            <div class="col-6">
                                <mat-form-field class="w-100">
                                    <input type="text"
                                        (focusout)="documents.code = documents.code == undefined ? '' : (documents.code + '').trim();convertData()"
                                        #focusCode matInput [placeholder]="'search_form.service_type_code' | translate"
                                        name="code" [(ngModel)]="documents.code" required autocomplete="off"
                                        #code="ngModel" maxlength="255" (ngModelChange)="onChangeFormInput('code')">
                                    <button mat-button *ngIf="documents.code" type="button" matSuffix mat-icon-button
                                        aria-label="Clear" (click)="documents.code=''">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                    <mat-error *ngIf="code.invalid">
                                        {{'validation.service_type_code_require' | translate}}
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <!-- Tên nhóm-->
                            <div class="col-6">
                                <mat-form-field class="w-100">
                                    <input type="text"
                                        (focusout)="documents.name = documents.name == undefined ? '' : (documents.name + '').trim()"
                                        #focusInput matInput [placeholder]="'search_form.service_type_name' | translate"
                                        name="name" [(ngModel)]="documents.name" required autocomplete="off"
                                        #name="ngModel" maxlength="255" (ngModelChange)="onChangeFormInput()">
                                    <button mat-button type="button" matSuffix mat-icon-button aria-label="Clear"
                                        *ngIf="documents.name" (click)="documents.name=''">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                    <mat-error *ngIf="name.invalid">
                                        {{'validation.service_type_name_require' | translate}}
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <!--Check box hợp đồng lao động-->
                            <div class="col-6 d-flex align-items-center" *ngIf="entType === '1' && isApplyContractMoha">
                                <input type="checkbox" name="checkbox_contract" class="custom-checkbox me-5"
                                    style="width: 16px; height: 16px;"
                                    [(ngModel)]="documents.isEmploymentContract" (click)="offAllowCheckSign();"
                                    [disabled]="documents.id" id="checkbox_contract">
                                <label style="margin-left: 10px; font-size: 14px; font-weight: 400;"
                                    for="checkbox_contract" class="mb-0">{{'search_form.checkbox_contact' |
                                    translate}}</label>
                            </div>

                          <!-- Loai HDLD -->
                          <div class="col-6" *ngIf="entType === '1' && isApplyContractMoha && documents.isEmploymentContract">
                            <mat-form-field class="w-50 group_mysign" >
                              <mat-label>{{'search_form.service_type_contract' | translate}}
                              </mat-label>
                              <mat-select [(value)]="selectedContract"
                                          (selectionChange)="onContractChange($event)"
                                          [disabled]="!documents.isEmploymentContract || documents.id">
                                <mat-option *ngFor="let contract of listContract"
                                            [value]="contract.value">
                                  {{ contract.viewValue | translate }}
                                </mat-option>
                              </mat-select>

                            </mat-form-field>
                            <mat-error *ngIf="documents.isEmploymentContract && !selectedContract">
                              {{'validation.not_select_contract' | translate}}
                            </mat-error>
                          </div>
                            <!-- Ghi chú -->
                            <div class="col-6" [ngClass]="{'col-12': !isShareMysignEnable, 'col-6': isShareMysignEnable}">
                                <mat-form-field class="w-100">
                                    <textarea (focusout)="documents.note=documents.note.trim()" type="text" matInput
                                        [placeholder]="'search_form.note' | translate" rows="1" name="note"
                                        maxlength="255" (ngModelChange)="onChangeFormInput()" id="description"
                                        [(ngModel)]="documents.note">
                                    </textarea>
                                </mat-form-field>
                            </div>
                            <!-- Nhóm Mysign -->
                            <div class="col-6"  *ngIf="isShareMysignEnable">
                              <mat-form-field class="w-100 group_mysign">
                                <mat-label>{{'search_form.service_type_groupName' | translate}}</mat-label>
                                <mat-select (selectionChange)="onChange($event)" [(value)]="selectedGroupId">
                                  <mat-option *ngIf="!groupsDTOS || groupsDTOS.length === 0"
                                              [value]="'default'">{{'search_form.service_type_noGroupName' | translate}}</mat-option>
                                  <mat-option *ngFor="let groupsDTO of groupsDTOS" [value]="groupsDTO.groupId">
                                    {{ groupsDTO.name }}
                                  </mat-option>
                                  <mat-option *ngIf="isLoading" disabled>
                                    <mat-spinner diameter="20"></mat-spinner>
                                  </mat-option>

                                </mat-select>
                                <button
                                  mat-button
                                  type="button"
                                  matSuffix
                                  mat-icon-button
                                  aria-label="Clear"
                                  *ngIf="isShowClearButton()"
                                  (click)="clearData()"
                                >
                                  <mat-icon>close</mat-icon>
                                </button>
                              </mat-form-field>
                              <span style="color: #f44336; font-size: 14px !important; display: block;">({{'validation.not_found_group_mysign' | translate}})</span>
                            </div>



                        </div>
                    </ng-template>
                    <section style="color: red; padding-left: 30px; font-style: italic"
                        *ngIf="haveConfig == 0 && documents.configGeneral == 1">
                        <span>{{'validation.config_general_not_found' | translate}}</span>
                        <a style="text-decoration: underline"
                            routerLink="/home-enterprise/document-group-manage">{{'header.enterprise_service_types' |
                            translate}}</a>
                        <span>{{'validation.to_setting' | translate}}</span>
                    </section>
                </mat-expansion-panel>
            </mat-accordion>
            <mat-card-content class="mb-3 mat-card-content-contract-sm">
                <!-- Cấu hình mã số hợp đồng tự động -->
                <mat-accordion>
                    <mat-expansion-panel expanded="true" class="mt-3">
                        <mat-panel-title class="mat-panel-title mt-3 d-flex justify-content-between align-items-center">
                            {{'search_form.auto_number' | translate}}
                            <mat-icon class="configure__head-help-icon"
                                style="position: absolute;cursor: pointer; padding-left: 340px !important;margin-top: 2px !important;"
                                (click)="createTplModal(tplHelpAutoTitle, tplHelpAutoContent, tplHelpAutoFooter,true)">
                                help_outline
                            </mat-icon>
                            <ng-template #tplHelpAutoTitle>
                                <span>{{'service_type.config_contract_code.config_contract_code_title' |
                                    translate}}</span>
                            </ng-template>
                            <ng-template #tplHelpAutoContent>
                                <p>{{'service_type.config_contract_code.modal_content1' | translate}}</p>
                                <p class="font-italic" style="margin-bottom: 0.5em !important;">
                                    <b>{{'service_type.config_contract_code.number_range' | translate}}</b>
                                    {{'service_type.config_contract_code.modal_content2' | translate}}
                                </p>
                                <ul class="font-italic" style="margin-bottom: 0.5em !important;">
                                    <li>{{'service_type.config_contract_code.number_range_ex_1' | translate}}</li>
                                    <li>{{'service_type.config_contract_code.number_range_ex_2' | translate}}</li>
                                    <li>{{'service_type.config_contract_code.number_range_ex_3' | translate}}</li>
                                    <li>{{'service_type.config_contract_code.number_range_ex_4' | translate}}</li>
                                    <li>{{'service_type.config_contract_code.number_range_ex_5' | translate}}</li>
                                    <li>{{'service_type.config_contract_code.number_range_ex_6' | translate}}</li>
                                </ul>
                                <p class="font-italic">{{'service_type.config_contract_code.modal_content3' |
                                    translate}}</p>
                                <p class="font-italic" style="margin-bottom: 0.5em !important;">
                                    <b>{{'service_type.config_contract_code.time' | translate}}</b>
                                    {{'service_type.config_contract_code.modal_content4' | translate}}
                                </p>
                                <ul class="font-italic" style="margin-bottom: 0.5em !important;">
                                    <li>{{'service_type.config_contract_code.time_dd' | translate}}</li>
                                    <li>{{'service_type.config_contract_code.time_mm' | translate}}</li>
                                    <li>{{'service_type.config_contract_code.time_yy' | translate}}</li>
                                    <li>{{'service_type.config_contract_code.time_yyyy' | translate}}</li>
                                </ul>
                                <p class="font-italic" style="margin-bottom: 0.5em !important;">
                                    {{'service_type.config_contract_code.modal_content5' | translate}}</p>
                                <p class="font-italic">{{'service_type.config_contract_code.modal_content6' |
                                    translate}}</p>
                                <p class="font-italic"><b>{{'service_type.config_contract_code.contract_type_code' |
                                        translate}}</b>
                                    {{'service_type.config_contract_code.modal_content7' | translate}}
                                </p>
                                <p class="font-italic"><b>{{'service_type.config_contract_code.input' | translate}}</b>
                                    {{'service_type.config_contract_code.modal_content8' | translate}}
                                </p>
                                <p>{{'service_type.config_contract_code.modal_content9' | translate}}</p>
                                <p class="font-italic" style="color: red;">
                                    <b>{{'service_type.config_contract_code.modal_content10' | translate}}</b>
                                    {{'service_type.config_contract_code.modal_content11' | translate}}
                                </p>
                            </ng-template>
                            <ng-template #tplHelpAutoFooter>
                                <button nz-button (click)="destroyTplModal()" class="v2-color-deny" type="button">
                                    {{'button.close' | translate}}
                                </button>
                            </ng-template>
                        </mat-panel-title>
                        <div class="row">
                            <!-- Cấu hình đánh số tự động-->
                            <div class="col-md-12 reminder-to-sign font-weight-bold">
                                {{'search_form.expriration_auto_number' | translate}}
                                <mat-button-toggle-group class="toggle-button">
                                    <mat-button-toggle [checked]="documents.isOnAutoNumber" value="on"
                                        (click)="clickSendAutoNumber(true)">{{'search_form.btn_config_notify_on' |
                                        translate}}
                                    </mat-button-toggle>
                                    <mat-button-toggle [checked]="!documents.isOnAutoNumber" value="off"
                                        (click)="clickSendAutoNumber(false)">{{'search_form.btn_config_notify_off' |
                                        translate}}
                                    </mat-button-toggle>
                                </mat-button-toggle-group>
                            </div>
                            <div class="col-md-12" style="margin-top:20px;" *ngIf="documents.isOnAutoNumber">
                                <span class="font-weight-bold"
                                    style="font-size: 15px; border-bottom: 1px solid #0000001f;padding: 20px 0px;">{{'search_form.config_contract_code_addendum'
                                    | translate}}</span>
                            </div>
                            <!--Loại cấu hình-->
                            <div class="col-md-12 reminder-to-sign mt-4" style="margin-bottom: 20px;"
                                *ngIf="documents.isOnAutoNumber">
                                <div style="width: 220px;">{{'search_form.contract_code_component' | translate}}</div>

                                <!-- Chọn thành phần -->
                                <div style="width:220px; margin-right: 40px;">
                                    <mat-form-field>
                                        <mat-label>{{'timestamp.table_header.type' | translate}}</mat-label>
                                        <mat-select (selectionChange)="onChangeSelectComponent($event,'ComponentType')"
                                            [(ngModel)]="selectedComponentType" name="selectedComponentType"
                                            id="selectedComponentType">
                                            <!-- <mat-option [value]=0 selected>{{'timestamp.table_header.type' | translate}}</mat-option> -->
                                            <mat-option *ngFor="let component of listKeyConfig"
                                                [value]="component.value">
                                                {{component.viewValue | translate}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <div *ngIf="invalidNumber" class="mat-error message-error">
                                        {{'validation.number_range_type_already_exists'| translate}}
                                    </div>
                                </div>
                                <!-- Định dạng -->
                                <div style="width:220px; margin-right: 40px;" *ngIf="!selectedComponentType">
                                    <mat-form-field>
                                        <mat-label>{{'search_form.format' | translate}}</mat-label>
                                        <mat-select disabled>
                                            <mat-option value="1"></mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <!-- Dải số -->
                                <div style="width:220px; margin-right: 40px;" *ngIf="selectedComponentType === 1">
                                    <mat-form-field>
                                        <!-- <mat-label>{{'search_form.component_number' | translate}}</mat-label> -->
                                        <mat-label>{{'search_form.format' | translate}}</mat-label>
                                        <mat-select [disabled]="invalidNumber != 0" (openedChange)="addSelect($event)"
                                            (selectionChange)="onChangeSelectComponent($event,'numberRange')"
                                            [(ngModel)]="selectedNumber" name="selectNumber" id="selectNumber">
                                            <mat-option *ngFor="let component of listNumber" [value]="component">
                                                {{ component.viewValue | translate}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <!-- time -->
                                <div style="width:220px; margin-right: 40px;" *ngIf="selectedComponentType === 2">
                                    <mat-form-field>
                                        <!-- <mat-label>{{'search_form.component_time' | translate}}</mat-label> -->
                                        <mat-label>{{'search_form.format' | translate}}</mat-label>
                                        <mat-select (openedChange)="addSelect($event)"
                                            (selectionChange)="onChangeSelectComponent($event,'time')"
                                            [(ngModel)]="selectedTime" name="selectTime" id="selectTime">
                                            <mat-option *ngFor="let component of listTime" [value]="component">
                                                {{component.viewValue | translate}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <!-- Mã loại hợp đồng -->
                                <div style="width:220px; margin-right: 40px;" *ngIf="selectedComponentType === 3">
                                    <mat-form-field>
                                        <!-- <mat-label>{{'search_form.component_text' | translate}}</mat-label> -->
                                        <input class="input-cycle" matInput disabled name="selectCode" id="selectCode"
                                            (ngModelChange)="onChangeFormInput()"
                                            [(ngModel)]="documents.code ? documents.code: constractCode"
                                            (keydown.space)="$event.preventDefault()" #timeNotify="ngModel">
                                    </mat-form-field>
                                </div>
                                <!-- text -->
                                <div style="width:220px; margin-right: 40px;" *ngIf="selectedComponentType === 4">
                                    <mat-form-field>
                                        <mat-label>{{'search_form.content' | translate}}</mat-label>
                                        <input (focusout)="selectedText=selectedText.trim()" class="input-cycle"
                                            matInput name="selectText" id="selectText"
                                            (ngModelChange)="onChangeFormInput('free_text')"
                                            (change)="onChangeFormInput('free_text')" [(ngModel)]="selectedText"
                                            #timeNotify="ngModel">
                                    </mat-form-field>
                                    <div *ngIf="invalidText && isSubmit" class="mat-error message-error">
                                        {{'validation.content_must_not_spaces' | translate}}
                                    </div>
                                </div>

                                <div style="width:220px;padding-bottom: 1.2em;">
                                    <button style="width: 90px!important;min-width: unset!important;"
                                        [disabled]="!selectedComponentType || (selectedComponentType !== 3 && !selectedNumber.value && !selectedTime.value && !selectedText)"
                                        mat-stroked-button type="button" color="primary" class="button"
                                        (click)="saveComponentType()">
                                        <mat-icon class="mr-0">add_circle</mat-icon>
                                        {{'search_form.add_component' | translate}}
                                    </button>
                                </div>
                            </div>

                            <div class="col-md-12" *ngIf="isFormChanging || isUpdate">
                                <p *ngIf="documents.isOnAutoNumber && listDataPreview.length > 0"
                                    style="font-size: 14px;">
                                    {{'search_form.selected_contract_code_format' |
                                    translate}} (<span style="font-style: italic;">{{'search_form.drag_and_change' |
                                        translate}}</span>)</p>

                                <div class="angular-container" cdkDropListGroup *ngIf="documents.isOnAutoNumber">
                                    <div cdkDropList [cdkDropListEnterPredicate]="dropListEnterPredicate"
                                        (cdkDropListDropped)="dropListDropped()"></div>
                                    <div cdkDropList *ngFor="let item of listDataPreview"
                                        [cdkDropListEnterPredicate]="dropListEnterPredicate"
                                        (cdkDropListDropped)="dropListDropped()">
                                        <div cdkDrag class="angular-box" (cdkDragMoved)="dragMoved($event)">
                                            <p class="viewValue" [class.viewText]="item.type == 4">
                                                {{ item.type == 4 ? (item.value.toString().length
                                                >
                                                30 ? item.value.slice(0,30) : item.value) : item.viewValue }}
                                                <span class="viewRangeNumber"
                                                    *ngIf="(item.type != 2 && item.type != 4 && item.type != 3) || (item.type == 3 && documents.code)">({{item.value.toString().trim().length
                                                    > 30 ? item.value.slice(0,30) :
                                                    item.value.toString().trim()}})</span>
                                                <span class="viewTime"
                                                    *ngIf="item.type == 2">({{item.displayValue}})</span>
                                                <span class="deleteComponent" (click)="deleteComponent(item)">
                                                    x
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-12 reminder-to-sign font-italic" style="font-weight: normal;"
                                *ngIf="documents.isOnAutoNumber && previewDataDisplay">
                                <span style="font-weight: normal;">{{'search_form.example_compnent' |
                                    translate}}&nbsp;</span>
                                <span [innerHTML]="previewDataDisplay">&nbsp;</span>
                            </div>
                            <div class="col-md-12 reminder-to-sign font-italic" *ngIf="documents.isOnAutoNumber">
                                <span>{{'history_report.note' | translate}}</span>&nbsp;
                                <span style="font-weight: normal;">{{'search_form.current_format_length' |
                                    translate}}</span>
                                <span class="preview-data" style="color: red;">{{vldMaxlength.length}}/50&nbsp;</span>
                                <span class="preview-data"> {{'search_form.max_contract_code_length' |
                                    translate}}</span>
                            </div>
                            <div class="col-md-12 reminder-to-sign font-italic" style="color: red;"
                                *ngIf="documents.isOnAutoNumber && vldMaxlength.length > 50">
                                {{'search_form.length_contract_maximum' | translate}}
                            </div>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>


            </mat-card-content>
            <mat-card-content class="mb-3 mat-card-content-contract-sm">
                <!-- Cấu hình loại hợp đồng -->
                <mat-accordion>
                    <mat-expansion-panel expanded="true" class="mt-3">
                        <mat-panel-title class="mat-panel-title mt-3 d-flex justify-content-between align-items-center">
                            {{'search_form.contract_type_config' | translate}}
                        </mat-panel-title>
                        <!--radio group-->
                        <div class="col-12 mb-3 d-flex">
                            <!--Checkbox cau hinh chung-->
                            <div class="group-checkbox px-3">
                                <button id="config-general" type="button" mat-icon-button class="v2-color-deny"
                                    [disabled]="documents.id && documents.type == 2 ? true : false"
                                    (click)="onAllowCheckSign('generalConfig')">
                                    <mat-icon *ngIf="documents.configGeneral === 1"
                                        [ngClass]="documents.id && documents.type == 2 ? '' : 'mat-primary'">
                                        radio_button_checked
                                    </mat-icon>
                                    <mat-icon *ngIf="documents.configGeneral !== 1"
                                        [ngClass]="documents.id && documents.type == 2 ? '' : 'mat-primary'">
                                        radio_button_unchecked
                                    </mat-icon>
                                </button>
                                <label class="checkbox-label" style="font-weight: 500;" for="config-general">
                                    {{'button.config' | translate}}
                                </label>
                            </div>
                            <!--Checkbox cau hinh rieng-->
                            <div class="group-checkbox px-3">
                                <button id="config-individual" type="button"
                                    [disabled]="documents.id && documents.type == 2 ? true : false" mat-icon-button
                                    class="v2-color-deny" (click)="onAllowCheckSign('individualConfig')">
                                    <mat-icon *ngIf="documents.configGeneral === 2"
                                        [ngClass]="documents.id && documents.type == 2 ? '' : 'mat-primary'">
                                        radio_button_checked
                                    </mat-icon>
                                    <mat-icon *ngIf="documents.configGeneral !== 2"
                                        [ngClass]="documents.id && documents.type == 2 ? '' :' mat-primary'">
                                        radio_button_unchecked
                                    </mat-icon>
                                </button>
                                <label class="checkbox-label" style="font-weight: 500;" for="config-individual">
                                    {{'button.individual_config' | translate}}
                                </label>
                            </div>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
            </mat-card-content>
            <mat-card-content class="mb-3 mat-card-content-contract-sm" *ngIf="documents.configGeneral == 2">
                <!--Cấu hình ký-->
                <mat-accordion>
                    <mat-expansion-panel expanded="true" class="mt-3">
                        <mat-panel-title class="mat-panel-title mt-3 d-inline-block justify-content-between align-items-center">
                            {{'header.sign_config' | translate}}
                            <mat-icon class="configure__head-help-icon"
                                style="cursor: pointer;"
                                (click)="createTplModal(tplHelpTitle, tplHelpContent, tplHelpFooter)">
                                help_outline
                            </mat-icon>
                            <ng-template #tplHelpTitle>
                                <span>{{'service_type.help_configure.modal_title' | translate}}</span>
                            </ng-template>
                            <ng-template #tplHelpContent>
                                <p><b>{{'service_type.help_configure.modal_content1' | translate}}</b>
                                    {{'service_type.help_configure.modal_content2' | translate}}
                                </p>
                                <p><b>{{'service_type.help_configure.modal_content3' | translate}}</b>
                                    {{'service_type.help_configure.modal_content4' | translate}}
                                </p>
                                <p><b>{{'service_type.help_configure.modal_content5' | translate}}</b>
                                    {{'service_type.help_configure.modal_content6' | translate}}
                                </p>
                                <p><b>{{'service_type.help_configure.modal_content7' | translate}}</b>
                                    {{'service_type.help_configure.modal_content8' | translate}}
                                </p>
                                <p><b>{{'service_type.help_configure.modal_content9' | translate}}</b>
                                    {{'service_type.help_configure.modal_content10' | translate}}
                                </p>

                                <p><b>{{'service_type.help_configure.modal_content15' | translate}}</b>
                                    {{'service_type.help_configure.modal_content16' | translate}}
                                    <span style="color: red;">{{'service_type.help_configure.modal_content_only_mobile'
                                        | translate}}</span>
                                </p>
                                <p><b>{{'service_type.help_configure.modal_content17' | translate}}</b>
                                    {{'service_type.help_configure.modal_content18' | translate}}
                                    <span style="color: red;">{{'service_type.help_configure.modal_content_only_mobile'
                                        | translate}}</span>
                                </p>

                                <p><b>{{'service_type.help_configure.modal_content11' | translate}}</b>
                                    {{'service_type.help_configure.modal_content12' | translate}}
                                </p>
                                <p><b>{{'service_type.help_configure.modal_content13' | translate}}</b>
                                    {{'service_type.help_configure.modal_content14' | translate}}
                                </p>
                            </ng-template>
                            <ng-template #tplHelpFooter>
                                <button nz-button (click)="destroyTplModal()" class="v2-color-deny" type="button">
                                    {{'button.close' | translate}}
                                </button>
                            </ng-template>
                        </mat-panel-title>

                                        <!--Ảnh ký của đối tác -->
                                        <p class="mt-3">{{'header.image_customer' | translate}}</p>
                                                <div class="form-group d-flex">
                                                    <div class="group-checkbox">
                                                        <button id="check_default_image" type="button" mat-icon-button class="v2-color-deny"
                                                            [disabled]="documents.id && documents.type == 2 ? true : false"
                                                            (click)="onAllowCheckSign('imageDefault')">
                                                            <mat-icon *ngIf="documents && documents?.customerImagesConfig?.includes('default_image')"
                                                                [ngClass]="documents.id && documents.type == 2 ? '' : 'mat-primary'">
                                                                check_box
                                                            </mat-icon>
                                                            <mat-icon *ngIf="documents && !documents?.customerImagesConfig?.includes('default_image')"
                                                                [ngClass]="documents.id && documents.type == 2 ? '' : 'mat-primary'">
                                                                check_box_outline_blank
                                                            </mat-icon>
                                                        </button>
                                                        <label class="checkbox-label pl-3 pr-2" style="margin-right: 0 !important;" for="check_default_image">
                                                            {{'search_form.default_image' | translate}}
                                                        </label>
                                                        <button *ngIf="entType === '2' && documents && documents?.customerImagesConfig?.includes('default_image')" type="button" mat-icon-button (click)="configDefaultImage()" matTooltip="{{ 'search_form.image_config_tooltip' | translate }}">
                                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M21.6748 14.6649L20.1397 13.3524C20.2123 12.9071 20.2498 12.4524 20.2498 11.9978C20.2498 11.5431 20.2123 11.0884 20.1397 10.6431L21.6748 9.33057C21.7906 9.23144 21.8735 9.09942 21.9124 8.95205C21.9513 8.80468 21.9445 8.64895 21.8928 8.50557L21.8717 8.44463C21.4491 7.26344 20.8162 6.16846 20.0037 5.2126L19.9615 5.16338C19.863 5.04749 19.7316 4.96418 19.5847 4.92443C19.4379 4.88468 19.2824 4.89036 19.1389 4.94072L17.2334 5.61807C16.5303 5.0415 15.7451 4.58682 14.8967 4.26807L14.5287 2.27588C14.501 2.12598 14.4282 1.98807 14.3202 1.88048C14.2122 1.77289 14.074 1.70071 13.924 1.67354L13.8607 1.66182C12.6397 1.4415 11.3553 1.4415 10.1342 1.66182L10.0709 1.67354C9.9209 1.70071 9.78271 1.77289 9.6747 1.88048C9.56669 1.98807 9.49398 2.12598 9.46622 2.27588L9.0959 4.27744C8.25424 4.59626 7.47043 5.0507 6.77559 5.62275L4.85606 4.94072C4.71254 4.88996 4.55698 4.88408 4.41003 4.92385C4.26309 4.96362 4.13173 5.04716 4.0334 5.16338L3.99122 5.2126C3.17968 6.16914 2.54694 7.26393 2.12325 8.44463L2.10215 8.50557C1.99668 8.79853 2.0834 9.12666 2.32012 9.33057L3.87403 10.6571C3.80137 11.0978 3.76622 11.5478 3.76622 11.9954C3.76622 12.4454 3.80137 12.8954 3.87403 13.3337L2.32012 14.6603C2.20433 14.7594 2.12146 14.8914 2.08252 15.0388C2.04359 15.1861 2.05043 15.3419 2.10215 15.4853L2.12325 15.5462C2.54747 16.7274 3.17559 17.8173 3.99122 18.7782L4.0334 18.8274C4.13197 18.9433 4.26333 19.0266 4.41019 19.0664C4.55704 19.1061 4.7125 19.1005 4.85606 19.0501L6.77559 18.3681C7.47403 18.9423 8.2545 19.397 9.0959 19.7134L9.46622 21.7149C9.49398 21.8648 9.56669 22.0027 9.6747 22.1103C9.78271 22.2179 9.9209 22.2901 10.0709 22.3173L10.1342 22.329C11.3665 22.5505 12.6284 22.5505 13.8607 22.329L13.924 22.3173C14.074 22.2901 14.2122 22.2179 14.3202 22.1103C14.4282 22.0027 14.501 21.8648 14.5287 21.7149L14.8967 19.7228C15.7448 19.4048 16.5344 18.9487 17.2334 18.3728L19.1389 19.0501C19.2824 19.1009 19.438 19.1067 19.5849 19.067C19.7318 19.0272 19.8632 18.9437 19.9615 18.8274L20.0037 18.7782C20.8193 17.8149 21.4475 16.7274 21.8717 15.5462L21.8928 15.4853C21.9982 15.197 21.9115 14.8688 21.6748 14.6649ZM18.4756 10.9196C18.5342 11.2735 18.5647 11.6368 18.5647 12.0001C18.5647 12.3634 18.5342 12.7267 18.4756 13.0806L18.3209 14.0204L20.0717 15.5181C19.8063 16.1295 19.4712 16.7083 19.0732 17.2431L16.8982 16.472L16.1623 17.0767C15.6022 17.536 14.9787 17.897 14.3037 18.1501L13.4107 18.4853L12.9912 20.7587C12.3293 20.8337 11.661 20.8337 10.999 20.7587L10.5795 18.4806L9.69356 18.1407C9.02559 17.8876 8.4045 17.5267 7.84903 17.0696L7.11309 16.4626L4.92403 17.2407C4.52559 16.704 4.19278 16.1251 3.92559 15.5157L5.69512 14.004L5.54278 13.0665C5.48653 12.7173 5.45606 12.3563 5.45606 12.0001C5.45606 11.6415 5.48418 11.2829 5.54278 10.9337L5.69512 9.99619L3.92559 8.48447C4.19043 7.87275 4.52559 7.29619 4.92403 6.75947L7.11309 7.5376L7.84903 6.93057C8.4045 6.47354 9.02559 6.1126 9.69356 5.85947L10.5818 5.52432L11.0014 3.24619C11.66 3.17119 12.3326 3.17119 12.9936 3.24619L13.4131 5.51963L14.3061 5.85478C14.9787 6.10791 15.6045 6.46885 16.1647 6.92822L16.9006 7.53291L19.0756 6.76182C19.474 7.29853 19.8068 7.87744 20.074 8.48682L18.3232 9.98447L18.4756 10.9196ZM11.9998 7.64072C9.72168 7.64072 7.87481 9.4876 7.87481 11.7657C7.87481 14.0438 9.72168 15.8907 11.9998 15.8907C14.2779 15.8907 16.1248 14.0438 16.1248 11.7657C16.1248 9.4876 14.2779 7.64072 11.9998 7.64072ZM13.8561 13.622C13.6126 13.8661 13.3233 14.0598 13.0047 14.1917C12.6861 14.3236 12.3446 14.3913 11.9998 14.3907C11.299 14.3907 10.6404 14.1165 10.1436 13.622C9.8994 13.3785 9.70578 13.0892 9.57385 12.7706C9.44192 12.452 9.37427 12.1105 9.37481 11.7657C9.37481 11.0649 9.64903 10.4063 10.1436 9.90947C10.6404 9.4126 11.299 9.14072 11.9998 9.14072C12.7006 9.14072 13.3592 9.4126 13.8561 9.90947C14.1002 10.1529 14.2938 10.4423 14.4258 10.7608C14.5577 11.0794 14.6253 11.4209 14.6248 11.7657C14.6248 12.4665 14.3506 13.1251 13.8561 13.622Z" fill="black"/>
                                                            </svg>
                                                        </button>
                                                    </div>
                                                    <div class="group-checkbox">
                                                        <button id="check_upload_image" type="button"
                                                            [disabled]="documents.id && documents.type == 2 ? true : false" mat-icon-button
                                                            class="v2-color-deny" (click)="onAllowCheckSign('uploadImage')">
                                                            <mat-icon *ngIf="documents && documents?.customerImagesConfig?.includes('download_sign_image')"
                                                                [ngClass]="documents.id && documents.type == 2 ? '' : 'mat-primary'">
                                                                check_box
                                                            </mat-icon>
                                                            <mat-icon *ngIf="documents && !documents?.customerImagesConfig?.includes('download_sign_image')"
                                                                [ngClass]="documents.id && documents.type == 2 ? '' : 'mat-primary'">
                                                                check_box_outline_blank
                                                            </mat-icon>
                                                        </button>
                                                        <label class="checkbox-label px-3" for="check_upload_image">
                                                            {{'search_form.upload_image_sign' | translate}}
                                                        </label>
                                                    </div>
                                                    <div class="group-checkbox">
                                                        <button id="check_draw_image" type="button"
                                                            [disabled]="documents.id && documents.type == 2 ? true : false" mat-icon-button
                                                            class="v2-color-deny" (click)="onAllowCheckSign('drawImage')">
                                                            <mat-icon *ngIf="documents && documents?.customerImagesConfig?.includes('draw_sign_image')"
                                                                [ngClass]="documents.id && documents.type == 2 ? '' : 'mat-primary'">check_box
                                                            </mat-icon>
                                                            <mat-icon *ngIf="documents && !documents?.customerImagesConfig?.includes('draw_sign_image')"
                                                                [ngClass]="documents.id && documents.type == 2 ? '' : 'mat-primary'">
                                                                check_box_outline_blank
                                                            </mat-icon>
                                                        </button>
                                                        <label class="checkbox-label px-3" for="check_draw_image">
                                                            {{'search_form.draw_image_sign' | translate}}
                                                        </label>
                                                    </div>
                                                </div>
                                                <ng-container *ngIf="documents && !documents?.customerImagesConfig?.length">
                                                    <div style="min-height: 30px !important;">
                                                        <mat-error
                                                          >
                                                          {{'validation.requied_select_image_customer' | translate}}
                                                        </mat-error>
                                                    </div>
                                                </ng-container>

                        <!--Kiểm tra-->
                        <p class="mt-3">{{'header.check' | translate}}</p>
                        <div class="form-group d-flex">
                            <div  class="group-checkbox">
                                <button [ngStyle]="{ 'opacity': this.documents.isVerifySubject? 0.5 : 1 }" id="check_num_document" type="button" mat-icon-button class="v2-color-deny"
                                    [disabled]="documents.id && documents.type == 2 || this.documents.isVerifySubject  ? true : false || documents.isEmploymentContract"
                                    (click)="onAllowCheckSign('checkCertNumber')">
                                    <mat-icon *ngIf="documents.checkCertNumber"
                                        [ngClass]="documents.id && documents.type == 2 ? '' : 'mat-primary'">
                                        check_box
                                    </mat-icon>
                                    <mat-icon *ngIf="documents.checkCertNumber === false"
                                        [ngClass]="documents.id && documents.type == 2 ? '' : 'mat-primary'">
                                        check_box_outline_blank
                                    </mat-icon>
                                </button>
                                <label class="checkbox-label px-3" for="check_num_document">
                                    {{'search_form.service_type_checkCertNumber' | translate}}
                                </label>
                            </div>
                            <div class="group-checkbox">
                                <button id="check_name" type="button"
                                    [disabled]="documents.id && documents.type == 2 ? true : false" mat-icon-button
                                    class="v2-color-deny" (click)="onAllowCheckSign('checkName')">
                                    <mat-icon *ngIf="documents.checkName"
                                        [ngClass]="documents.id && documents.type == 2 ? '' : 'mat-primary'">
                                        check_box
                                    </mat-icon>
                                    <mat-icon *ngIf="documents.checkName === false"
                                        [ngClass]="documents.id && documents.type == 2 ? '' : 'mat-primary'">
                                        check_box_outline_blank
                                    </mat-icon>
                                </button>
                                <label class="checkbox-label px-3" for="check_name">
                                    {{'search_form.service_type_checkName' | translate}}
                                </label>
                            </div>
                            <div  class="group-checkbox">
                                <button [ngStyle]="{ 'opacity': this.documents.isVerifySubject? 0.5 : 1 }" id="check_otp" type="button"
                                    [disabled]="documents.id && documents.type == 2 || this.documents.isVerifySubject  ? true : false" mat-icon-button
                                    class="v2-color-deny" (click)="onAllowCheckSign('checkOtp')">
                                    <mat-icon *ngIf="documents.checkOtp"
                                        [ngClass]="documents.id && documents.type == 2 ? '' : 'mat-primary'">check_box
                                    </mat-icon>
                                    <mat-icon *ngIf="documents.checkOtp === false"
                                        [ngClass]="documents.id && documents.type == 2 ? '' : 'mat-primary'">
                                        check_box_outline_blank
                                    </mat-icon>
                                </button>
                                <label class="checkbox-label px-3" for="check_otp">
                                    {{'search_form.service_type_checkOtp' | translate}}
                                </label>
                            </div>
                        </div>
<!--                      Xác minh chủ thể-->
                        <p *ngIf="isNotAttestedUser">{{'kyc.confirm_account' | translate}}</p>
                        <div class="form-group d-flex" *ngIf="isNotAttestedUser">
                            <div class="group-checkbox" style="width: 60rem; display: flex;">
                            <button id="check_xmct" type="button"
                                    mat-icon-button class="v2-color-deny"
                                    (click)="onClickVerifySubject()">
                                <mat-icon *ngIf="documents.isVerifySubject"  [ngClass]="documents.id && documents.type == 2 ? '' : 'mat-primary'">check_box</mat-icon>
                                <mat-icon *ngIf="documents.isVerifySubject === false"  [ngClass]="documents.id && documents.type == 2 ? '' : 'mat-primary'">
                                check_box_outline_blank
                                </mat-icon>
                            </button>
                            <label style="min-width: 60rem; padding-top: 6px;" class="checkbox-label px-3" for="check_xmct">
                                <i> {{'search_form.service_type_xmct1' | translate}} </i> <b>{{'search_form.service_type_xmct2' | translate}}</b> <i>{{'search_form.service_type_xmct3' | translate}}</i>
                            </label>
                            </div>
                        </div>
                        <!-- Luồng ký - duyệt nội bộ -->
                        <p>{{'sign_internal.title' | translate}}</p>
                        <div class="form-group d-flex">
                            <div class="group-checkbox" style="width: 60rem; display: flex;">
                            <button id="check_xmct" type="button"
                                    mat-icon-button class="v2-color-deny"
                                    (click)="onClickSignInternal()">
                                <mat-icon *ngIf="documents.internalFlowNotEdit"  class="mat-primary">check_box</mat-icon>
                                <mat-icon *ngIf="documents.internalFlowNotEdit === false"  class="mat-primary">
                                check_box_outline_blank
                                </mat-icon>
                            </button>
                            <label style="min-width: 60rem; margin-bottom: 0;" class="checkbox-label px-3" for="check_sign">
                                <i> {{'sign_internal.note_sign1' | translate}} </i> <b>{{'sign_internal.note_sign2' | translate}}</b> <i>{{'sign_internal.note_sign3' | translate}}</i>
                            </label>
                            </div>
                        </div>
                        <!-- ký 1 lần -->
                        <p *ngIf="checkSignOneTurn()">{{'search_form.sign_once' | translate}}</p>
                        <div class="form-group d-flex" *ngIf="checkSignOneTurn()">
                            <div class="group-checkbox" style="width: 60rem; display: flex;">
                            <button id="sign_once" type="button"
                                    mat-icon-button class="v2-color-deny"
                                    (click)="onClickSignOneTime()">
                                <mat-icon *ngIf="documents.enableSignOneTime"  class="mat-primary">check_box</mat-icon>
                                <mat-icon *ngIf="documents.enableSignOneTime === false"  class="mat-primary">
                                check_box_outline_blank
                                </mat-icon>
                            </button>
                            <label style="min-width: 60rem; margin-bottom: 0;" class="checkbox-label px-3" for="sign_once">
                                <i> {{'search_form.allow_sign_once' | translate}} </i>
                            </label>
                            </div>
                        </div>
                        <!--Phương thức ký-->
                        <p>{{'header.signing_method' | translate}}</p>
                        <div class="mb-3 mt-3">
                            <div class="form-group">
                                <table class="mat-table" border="1" style="text-align: center; height: 7rem;">
                                    <tr class="mat-header-row" style="height: 50px;">
                                        <th class="mat-header-cell" style="width: 10%;"></th>
                                        <th class="mat-header-cell" style="width: 30%;">{{'header.signing_method' | translate}}</th>
                                        <th class="mat-header-cell" style="width: 60%;">{{'search_form.config_detail' |
                                            translate}}</th>
                                    </tr>
                                    <tr class="mat-row justify-content-center">
                                        <td class="mat-cell">
                                            <button id="sign-otp" style="margin: 0 15px;"
                                                [disabled]="documents.isEmploymentContract || documents.id && documents.type == 2 ? true : false"
                                                mat-icon-button class="v2-color-deny" type="button"
                                                (click)="onAllowCheckSign('allowOtp')">
                                                <mat-icon *ngIf="documents.allowOtp"
                                                    [ngClass]="documents.isEmploymentContract || (documents.id && documents.type == 2) ? '' : 'mat-primary'">
                                                    check_box
                                                </mat-icon>
                                                <mat-icon
                                                    *ngIf="documents.allowOtp === false || documents.isEmploymentContract"
                                                    [ngClass]="documents.isEmploymentContract || (documents.id && documents.type == 2) ? '' : 'mat-primary'">
                                                    check_box_outline_blank
                                                </mat-icon>
                                            </button>
                                        </td>
                                        <td class="mat-cell">{{'search_form.service_type_allowOtp' | translate}}</td>
                                        <td class="mat-cell">
                                            <div class="config-container">
                                                <label class="label-config">
                                                    {{'search_form.limit_times_OTP' | translate}}
                                                </label>
                                                <div class="config-ekyc">
                                                    <button id="number-sign-otp" [disabled]="!documents.allowOtp"
                                                        mat-icon-button class="v2-color-deny" type="button"
                                                        [ngStyle]="{ 'pointer-events': !documents.allowOtp ? 'none' : 'auto'}"
                                                        (click)="onAllowSendOTP()">
                                                        <mat-icon *ngIf="isOtpLimited"
                                                            [ngClass]="!documents.allowOtp ? '' : 'mat-primary'">
                                                            check_box
                                                        </mat-icon>
                                                        <mat-icon *ngIf="!isOtpLimited"
                                                            [ngClass]="!documents.allowOtp ? '' : 'mat-primary'">
                                                            check_box_outline_blank
                                                        </mat-icon>
                                                    </button>

                                                    <span class="text-checkbox">{{'search_form.number_of_times' | translate}}</span>
                                                    <div>
                                                        <mat-form-field class="w-100 otp-limit" style="width: 208px !important; font-size: 14px !important;">
                                                            <mat-label>{{'search_form.enter_the_number' | translate}}</mat-label>
                                                            <input type="text" #focusInput
                                                            (focusout)="otpLimitedNumber = otpLimitedNumber ? otpLimitedNumber.trim() : ''; isRequiredOTP = true"
                                                            matInput name="otpLimitedNumber" [disabled]="!isOtpLimited || !documents.allowOtp"
                                                            [(ngModel)]="otpLimitedNumber" autocomplete="off" class="input-enter"
                                                            (keypress)="allowOnlyNumbers($event)"
                                                            (blur)="normalizeValue($event)"
                                                            (ngModelChange)="changeValue($event)"
                                                            [required]="documents.allowOtp && isOtpLimited"
                                                            />
                                                            <button mat-button type="button" matSuffix mat-icon-button aria-label="Clear"
                                                                *ngIf="otpLimitedNumber && isOtpLimited && documents.allowOtp" (click)="otpLimitedNumber=''">
                                                                <mat-icon>close</mat-icon>
                                                            </button>
                                                            <mat-error style="display: none;" *ngIf="otpLimitedNumber.length == 0 && isRequiredOTP">
                                                                {{'validation.required_enter_otp_number' | translate}}
                                                            </mat-error>
                                                            <p class="validateNumber" *ngIf="otpLimitedNumber.length == 0 && isRequiredOTP && documents.allowOtp && isOtpLimited">
                                                                {{'validation.required_enter_otp_number' | translate}}
                                                            </p>
                                                            <p class="validateNumber" *ngIf="otpLimitedNumber.length > 0 && isInvalidMaxMin && documents.allowOtp && isOtpLimited">
                                                                {{'validation.max_min_enter_otp_number' | translate}}
                                                            </p>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                                <label class="label-config">
                                                {{'search_form.service_type_supportEKYC' | translate}}
                                                </label>
                                                <div class="config-ekyc">
                                                    <div class="config-ekyc-item" style="margin-right: 80px">
                                                        <button id="sign-ekyc" type="button" mat-icon-button
                                                            [ngStyle]="{ 'pointer-events': !documents.allowOtp ? 'none' : 'auto'}"
                                                            class="v2-color-deny"
                                                            [disabled]="isDisableEkyc || (!documents.allowOtp && !documents.allowImage) || (documents.id && documents.type == 2)"
                                                            (click)="onAllowCheckSign('supportEkyc')">
                                                            <mat-icon
                                                                *ngIf="documents.ekycSupportConfig === 1 && !isDisableEkyc"
                                                                [ngClass]="isDisableEkyc || (!documents.allowOtp && !documents.allowImage) || (documents.id && documents.type == 2) ? '' : 'mat-primary'">
                                                                radio_button_checked
                                                            </mat-icon>
                                                            <mat-icon
                                                                *ngIf="documents.ekycSupportConfig !== 1 && !isDisableEkyc"
                                                                [ngClass]="isDisableEkyc || (!documents.allowOtp && !documents.allowImage) || (documents.id && documents.type == 2) ? '' : 'mat-primary'">
                                                                radio_button_unchecked
                                                            </mat-icon>
                                                            <mat-icon *ngIf="isDisableEkyc" class="color-gray">
                                                                radio_button_unchecked
                                                            </mat-icon>
                                                        </button>
                                                        <label class="checkbox-label"
                                                            for="sign-ekyc" [class.color-gray]="isDisableEkyc">
                                                            {{'search_form.service_type_EKYC' | translate}}
                                                        </label>
                                                    </div>

                                                    <div class="config-ekyc-item">
                                                        <button id="sign-advanced-ekyc" type="button" mat-icon-button
                                                            [ngStyle]="{ 'pointer-events': !documents.allowOtp ? 'none' : 'auto'}"
                                                            class="v2-color-deny"
                                                            [disabled]="isDisableEkycAdvanced || (!documents.allowOtp && !documents.allowImage) || (documents.id && documents.type == 2)"
                                                            (click)="onAllowCheckSign('supportEkycAdvanced')">
                                                            <mat-icon
                                                                *ngIf="documents.ekycSupportConfig === 2 && !isDisableEkycAdvanced"
                                                                [ngClass]="isDisableEkycAdvanced || (!documents.allowOtp && !documents.allowImage) || (documents.id && documents.type == 2) ? '' : 'mat-primary'">
                                                                radio_button_checked
                                                            </mat-icon>
                                                            <mat-icon
                                                                *ngIf="documents.ekycSupportConfig !== 2 && !isDisableEkycAdvanced"
                                                                [ngClass]="isDisableEkycAdvanced || (!documents.allowOtp && !documents.allowImage) || (documents.id && documents.type == 2) ? '' : 'mat-primary'">
                                                                radio_button_unchecked
                                                            </mat-icon>
                                                            <mat-icon *ngIf="isDisableEkycAdvanced" class="color-gray">
                                                                radio_button_unchecked
                                                            </mat-icon>
                                                        </button>
                                                        <label class="checkbox-label"
                                                            for="sign-advanced-ekyc"
                                                            [class.color-gray]="isDisableEkycAdvanced">
                                                            {{'search_form.service_type_EkycAdvanced' | translate}}
                                                        </label>
                                                    </div>
                                                </div>

                                            </div>

                                        </td>
                                    </tr>
                                    <!-- <tr class="mat-row">
                                        <td class="mat-cell">{{'search_form.service_type_allowImage' | translate}}</td>
                                        <td class="mat-cell">
                                            <button id="sign-image"
                                                    style="margin: 0 15px;" type="button"
                                                    mat-icon-button class="v2-color-deny"
                                                    (click)="onAllowCheckSign('allowImage')">
                                                <mat-icon *ngIf="documents.allowImage" class="mat-primary">check_box
                                                </mat-icon>
                                                <mat-icon *ngIf="documents.allowImage === false" class="mat-primary">
                                                    check_box_outline_blank
                                                </mat-icon>
                                            </button>
                                        </td>
                                    </tr> -->
                                </table>
                            </div>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
                <!-- Lưu ý -->
                <ng-container *ngIf="documents.id && documents.type == 2">
                    <div class="w-100 note-class">
                        <div class="d-flex align-items-center">
                            <i class="fa fa-exclamation-circle" style="color: red; font-size: 20px;"
                                aria-hidden="true"></i>
                            <div style="color: red;" class="font-weight-bold ml-3">{{'title.note' | translate}}</div>
                        </div>
                        <div style="padding-left: 33px;">{{'service_type.message_service_type' | translate}}</div>
                    </div>
                </ng-container>
                <!--Cấu hình thông báo-->
                <mat-accordion>
                    <mat-expansion-panel expanded="true" class="mt-3">
                        <mat-panel-title class="mat-panel-title mt-3 d-flex justify-content-between align-items-center">
                            {{'search_form.notification_config' | translate}}
                        </mat-panel-title>
                        <div class="col-12">
                            <mat-tab-group mat-align-tabs="center" mat-stretch-tabs>
                                <!-- Tiến trình xử lý-->
                                <mat-tab
                                    [label]="'service_type.remind_configuration.configure_notify_sms_contract' | translate">
                                    <div class="reminder-to-sign"> {{'service_type.remind_configuration.set_send_sms' |
                                        translate}}
                                        <mat-button-toggle-group class="toggle-button">
                                            <mat-button-toggle [checked]="documents.isOnSMSInFlow"
                                                [value]="documents.isOnSMSInFlow"
                                                (click)="clickChangeSMSConfiguration(true)">
                                                {{'service_type.remind_configuration.on_status' | translate}}
                                            </mat-button-toggle>
                                            <mat-button-toggle [checked]="!documents.isOnSMSInFlow"
                                                [value]="!documents.isOnSMSInFlow"
                                                (click)="clickChangeSMSConfiguration(false)">
                                                {{'service_type.remind_configuration.off_status' | translate}}
                                            </mat-button-toggle>
                                        </mat-button-toggle-group>
                                    </div>
                                    <div class="reminder-to-sign" *ngIf=documents.isOnSMSInFlow>
                                      {{'service_type.remind_configuration.means_of_sending_notification' | translate}}
                                      <div>
                                          <mat-checkbox class="pl-5" color="primary" [checked]="isCheckSMSInFlow"
                                                        (change)="checkBoxSendSMSCustomerInflow()">
                                            SMS
                                          </mat-checkbox>
                                      </div>
                                      <div>
                                          <mat-checkbox class="px-5" color="primary"
                                                        [checked]="checkEmailInFlow(documents?.notificationServiceTypes)"
                                                        (change)="checkSendEmailCustomerInflow()">
                                            Email
                                          </mat-checkbox>
                                      </div>
                                    </div>
                                  <div>
                                    <mat-error
                                      *ngIf="isCheckEmailInFlow == false && isCheckSMSInFlow === false && documents.isOnSMSInFlow">
                                      {{'validation.selectObjectValidate' | translate}}
                                    </mat-error>
                                  </div>

                                    <!--Đối tượng nhắc ký-->
                <!--                                  Send SMS-->
                <div style="margin-top: 10px" *ngIf=documents.isOnSMSInFlow>
                    {{'service_type.remind_configuration.send_sms_object' | translate}}
                    <span>*</span>
                    <div class="sign-prompt-object">
                      <div style="padding-right: 15px;">
                        <div style="margin-top: 10px;">
                            <mat-checkbox class="px-1" color="primary" style="font-weight: bold;"
                            [checked]="documents.sendSMSCustomerInFlow?.includes('1') || documents.sendSMSCustomerInFlow?.includes('2') || documents.sendSMSCustomerInFlow?.includes('3') || documents.sendSMSCustomerInFlow?.includes('5')"
                            [disabled]="!isCheckSMSInFlow"
                            (change)="checkSendSMSCustomerInFlow()">
                            {{'search_form.customer' | translate}}
                          </mat-checkbox>
                        </div>
                        <div style="margin-top: 10px;">
                            <mat-checkbox class="px-1" color="primary" style="font-weight: bold;"
                            [disabled]="!isCheckSMSInFlow"
                            [checked]="documents.sendSMSInternalInFlow?.includes('1') || documents.sendSMSInternalInFlow?.includes('2') || documents.sendSMSInternalInFlow?.includes('3') || documents.sendSMSInternalInFlow?.includes('5')"
                            (change)="checkSendSMSInternalInFlow()">
                            {{'search_form.internal' | translate}}
                          </mat-checkbox>
                        </div>
                      </div>
                      <div>
                        <div>
                            <button mat-stroked-button color="primary" type="button" style="font-weight: bold;"
                                   [disabled]="!isCheckSMSInFlow || (documents.sendSMSCustomerInFlow && documents.sendSMSCustomerInFlow.includes('0'))"
                                    (click)="chonSuKienGuiSMS('customer', 'PROCESS')">
                                {{'service_type.remind_configuration.select_event_sms' | translate}}
                              </button>
                            </div>
                        <div>
                          <button mat-stroked-button color="primary" type="button" style="margin-top: 10px; font-weight: bold;"
                          [disabled]="!isCheckSMSInFlow || (documents.sendSMSInternalInFlow && documents.sendSMSInternalInFlow.includes('0'))"
                          (click)="chonSuKienGuiSMS('internal', 'PROCESS')">
                          {{'service_type.remind_configuration.select_event_sms' | translate}}
                        </button>
                        </div>
                      </div>
                    </div>

    <div style="min-height: 30px !important; padding-top: 50px">
      <mat-error
        *ngIf="checkIsErrorProcess()">
        {{'validation.selectObjectToSendSMS' | translate}}
      </mat-error>
    </div>
  </div>
<!--                                  Send mail-->
                                  <div style="margin-top: 10px" *ngIf="documents.isOnSMSInFlow">
                                    {{'service_type.remind_configuration.send_mail_object' | translate}}
                                    <span>*</span>
                                    <div class="sign-prompt-object">
                                      <div style="padding-left: 48px;" >
                                        <mat-checkbox color="primary" [checked]="getEmailConfig(documents.notificationServiceTypes)"
                                                      [disabled]="!isCheckEmailInFlow"
                                                      (change)="checkSendMailCustomerInFlow()">
                                          {{'search_form.customer' | translate}}
                                        </mat-checkbox>
                                      </div>
                                      <div>
                                        <mat-checkbox class="px-5" color="primary"
                                                      [checked]="checkboxSendEmailInternalInFlow(documents.notificationServiceTypes)"
                                                      [disabled]="!isCheckEmailInFlow"
                                                      (change)="checkSendEmailInternalInFlow()">
                                          {{'search_form.internal' | translate}}
                                        </mat-checkbox>
                                      </div>
                                      <div>
                                        <mat-form-field>
                                          <mat-label>{{'service_type.remind_configuration.internal_object' |
                                            translate}}</mat-label>
                                          <mat-select #select multiple
                                                      [value]="cbxSendEmailInternalInFlow()"
                                                      [disabled]="!isCheckEmailInFlow"
                                                      (valueChange)="documents.notificationServiceTypes[getIndex()].sendEmailInternal = $event">
                                            <mat-option
                                              *ngFor="let internalObject of internalObjectsToSendSMS"
                                              [value]="internalObject.value"
                                              (click)="formChangingCheckSendEmailInternalInFlowEvent()">
                                              {{internalObject.viewValue | translate}}
                                            </mat-option>
                                          </mat-select>
                                        </mat-form-field>
                                      </div>
                                    </div>
                                    <div style="min-height: 30px !important; padding-top: 15px">
                                      <mat-error
                                        *ngIf="isCheckEmailInFlow == true && !checkValidateEmail(documents.notificationServiceTypes)">
                                        {{'validation.selectObjectToSendEmail' | translate}}
                                      </mat-error>
                                    </div>
                                  </div>
                                    <div>
                                        <span style="font-style: italic;">
                                            <span style="color: red;"> {{'service_type.remind_configuration.note' |
                                                translate}}
                                            </span>
                                            <span [innerHTML]="getNoteMesage()">
                                            </span>
                                        </span>
                                    </div>
                                </mat-tab>

                                <!-- Nhắc xử lý tự động-->
                                <mat-tab [label]="'search_form.reminder_to_sign' | translate">
                                    <div class="reminder-to-sign"> {{'search_form.reminder_to_sign_contract' |
                                        translate}}
                                        <mat-button-toggle-group class="toggle-button">
                                            <mat-button-toggle [checked]="documents.isOnPromptToSign" id="on-button"
                                                [value]="documents.isOnPromptToSign" (click)="clickSend(true)">
                                                {{'search_form.btn_config_notify_on' | translate}}
                                            </mat-button-toggle>
                                            <mat-button-toggle [checked]="!documents.isOnPromptToSign"
                                                [value]="!documents.isOnPromptToSign" (click)="clickSend(false)">
                                                {{'search_form.btn_config_notify_off' | translate}}
                                            </mat-button-toggle>
                                        </mat-button-toggle-group>
                                    </div>

                                    <!--Loại cấu hình-->
                                    <div class="reminder-to-sign" *ngIf="documents.isOnPromptToSign">
                                      {{'service_type.remind_configuration.means_of_sending_notification' | translate}}
                                        <mat-checkbox class="mat-checkbox px-5" color="primary"
                                            [disabled]="!documents.isOnPromptToSign"
                                            style="margin-right: 14px;"
                                            (change)="documents.isSendSmsSign = !documents.isSendSmsSign; checkoff()"
                                            (click)="remindSmsChange()" [checked]="documents.isSendSmsSign">
                                            SMS
                                        </mat-checkbox>
                                        <mat-checkbox class="mat-checkbox" color="primary" checked="true"
                                                      [checked]="isCheckEmailSign"
                                                      (change)="checkSendEmailCustomerSign()">
                                            Email
                                        </mat-checkbox>

                                        <mat-checkbox class="mat-checkbox px-5" color="primary" checked="true"
                                            [checked]="isCheckApiSign"
                                            (change)="checkSendApiCustomerSign()">
                                            API<span class="text-normal">{{'search_form.api_only_customer' | translate}}</span>
                                        </mat-checkbox>
                                    </div>
                                  <div>
                                    <mat-error
                                      *ngIf="isCheckEmailSign == false && documents.isSendSmsSign === false && documents.isOnPromptToSign && isCheckApiSign == false">
                                      {{'validation.selectObjectValidate' | translate}}
                                    </mat-error>
                                  </div>

                                  <div style="align-items: flex-start; gap: 40px; margin-top: 10px" *ngIf="documents.isOnSMSInFlow || documents.isOnPromptToSign">
                                    <div style="display: flex;">
                                    <!-- Cột trái: Đối tượng gửi SMS -->
                                    <div style="min-width: 300px" *ngIf="documents.isOnPromptToSign">
                                      {{'search_form.sign_prompt_object' | translate}}
                                      <span>*</span>
                                      <div class="sign-prompt-object">
                                        <div style="padding-right: 15px;">
                                          <div style="margin-top: 10px;">
                                            <mat-checkbox class="px-1" color="primary" style="font-weight: bold;"
                                              [checked]="documents.isSendCustomerSign"
                                              [disabled]="documents.isSendSmsSign === false"
                                              (change)="checkCustomerSms()">
                                              {{'search_form.customer' | translate}}
                                            </mat-checkbox>
                                          </div>
                                          <div style="margin-top: 10px;">
                                            <mat-checkbox class="px-1" color="primary" style="font-weight: bold;"
                                              [disabled]="documents.isSendSmsSign === false"
                                              [checked]="documents.sendInternalSign?.includes('1') || documents.sendInternalSign?.includes('2') || documents.sendInternalSign?.includes('3') || documents.sendInternalSign?.includes('5')"
                                              (change)="checkInternalSms()">
                                              {{'search_form.internal' | translate}}
                                            </mat-checkbox>
                                          </div>
                                        </div>
                                        <div>
                                          <div style="padding-top: 15px;">
                                            <button mat-stroked-button color="primary" type="button" style="font-weight: bold;"
                                              [disabled]="!documents.isSendCustomerSign || (documents.isSendSmsSign === false)"
                                              (click)="chonSuKienGuiSMS('customer', 'REMINDER')">
                                              {{'service_type.remind_configuration.select_event_sms' | translate}}
                                            </button>
                                          </div>
                                          <div style="padding-top: 8px;">
                                            <button mat-stroked-button color="primary" type="button" style="margin-bottom: 10px; font-weight: bold;"
                                              [disabled]="!(documents.sendInternalSign?.includes('1') || documents.sendInternalSign?.includes('2') || documents.sendInternalSign?.includes('3') || documents.sendInternalSign?.includes('5')) || (documents.isSendSmsSign === false)"
                                              (click)="chonSuKienGuiSMS('internal', 'REMINDER')">
                                              {{'service_type.remind_configuration.select_event_sms' | translate}}
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>



                                    <!-- Cột phải: Email & api -->
                                      <div style="padding-left: 40px; min-width: 300px;" *ngIf="documents.isOnPromptToSign">
                                        {{'search_form.sign_prompt_object_email_api' | translate}}
                                        <span>*</span>

                                       <div style="gap: 60px; display: flex;">

                                          <!-- Nhóm checkbox -->
                                          <div style="padding-top: 20px; gap: 60px; display: flex;">
                                            <div>
                                              <mat-checkbox color="primary"
                                                           [checked]="documents.isSendPromptEmailCustomerSign"
                                                           [disabled]="isCheckEmailSign == false"
                                                           (change)="checkCustomer()">
                                                {{'search_form.customer' | translate}}
                                              </mat-checkbox>
                                            </div>
                                            <div>
                                              <mat-checkbox color="primary"
                                                            [disabled]="isCheckEmailSign == false"
                                                            [checked]="documents.sendPromptEmailInternalSign && documents.sendPromptEmailInternalSign.length > 0"
                                                            (change)="checkInternal()">
                                                {{'search_form.internal' | translate}}
                                              </mat-checkbox>
                                            </div>
                                          </div>

                                         <!-- Select đối tượng nội bộ -->
                                         <div>
                                           <mat-form-field>
                                             <mat-label>{{'search_form.internal_object' | translate}}</mat-label>
                                             <mat-select #select multiple
                                                         [value]="documents.sendPromptEmailInternalSign"
                                                          (valueChange)="changeValueSign($event)">
                                                <mat-option *ngFor="let internalObject of internalObjects"
                                                            [value]="internalObject.value"
                                                            (click)="formChangingCheckInternalRemindEvent()">
                                                  {{internalObject.viewValue | translate}}
                                                </mat-option>
                                              </mat-select>
                                            </mat-form-field>
                                          </div>

                                        </div>
                                      </div>

                                    </div>
                                    <div style="min-height: 30px !important; padding-top: 50px" *ngIf="documents.isOnPromptToSign">
                                        <mat-error
                                          *ngIf="checkIsErrorRemind() || checkIsErrorRemindEmail()">
                                          {{'validation.signPromptObject' | translate}}
                                        </mat-error>
                                    </div>
                                    <!-- Cột phải: Chu kỳ nhắc xử lý -->
                  <div style="flex: 1; min-width: 260px" *ngIf="documents.isOnPromptToSign">
                    <div class="reminder-to-sign" *ngIf="documents.isOnPromptToSign">
                      <mat-form-field class="w-100">
                        <input type="number" min="1" maxlength="9" style="width: 100% !important;"
                               oninput="validity.valid||(value=''); if (Number(this.value) > 30) this.value = '30'"
                               class="input-cycle" required matInput
                               [placeholder]="'search_form.cycle_send_sign' | translate"
                               name="cycleSendSign" [(ngModel)]="documents.cycleSendSign"
                               #cycleSendSign="ngModel" (ngModelChange)="onChangeCycleSendSignOrNotifyExpire()">
                        <span matSuffix>{{'search_form.day_time' | translate}}</span>
                        <mat-error *ngIf="cycleSendSign.invalid">
                          {{'validation.cycle_sign_validate' | translate}}
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                                    </div>
                                    <div class="reminder-to-sign"><span style="font-style: italic; font-weight: normal;"><span
                                                style="color: red;">
                                                {{'search_form.note_remind_sign_contract_pre' | translate}} </span>
                                            {{'search_form.note_remind_sign_contract' | translate}}</span>
                                    </div>
                                </mat-tab>

                                <!-- Nhắc hết hạn-->
                                <mat-tab [label]="'search_form.expiration_reminder' | translate">
                                    <div class="reminder-to-sign">
                                        <div>
                                            <div>{{'search_form.expiration_reminder_contract' | translate}}</div>
                                            <div style="font-style: italic; color: gray; font-weight: normal;">({{'search_form.include_contract_digitization' | translate}})</div>
                                        </div>
                                        <mat-button-toggle-group class="toggle-button">
                                            <mat-button-toggle [checked]="documents.isOnNotifyExpireContract" value="on"
                                                (click)="clickSendExpire(true)">{{'search_form.btn_config_notify_on' |
                                                translate}}
                                            </mat-button-toggle>
                                            <mat-button-toggle [checked]="!documents.isOnNotifyExpireContract"
                                                value="off" (click)="clickSendExpire(false)">
                                                {{'search_form.btn_config_notify_off' | translate}}
                                            </mat-button-toggle>
                                        </mat-button-toggle-group>
                                    </div>

                                    <!--Loại cấu hình-->
                                    <div class="reminder-to-sign" *ngIf="documents.isOnNotifyExpireContract">
                                        <div class="notify-method-wrapper">
                                          <span class="notify-method-label">{{'service_type.remind_configuration.means_of_sending_notification' | translate}}</span>
                                          <div class="notify-method-col">
                                            <div class="notify-method-row">
                                              <mat-checkbox class="mat-checkbox px-5" color="primary" style="padding-top: 4px;"
                                              (change)="checkSmsExpire()"
                                                [checked]="documents.isSendSmsExpireContract"
                                                (click)="isFormChanging = true">SMS</mat-checkbox>

                                              <button mat-stroked-button color="primary" type="button" style="font-weight: bold;"
                                                [disabled]="!documents.isSendSmsExpireContract"
                                                (click)="chonSuKienGuiSMS('internal', 'EXPIRY_REMINDER')">
                                                {{'service_type.remind_configuration.select_event_sms' | translate}}
                                              </button>
                                            </div>

                                            <mat-checkbox class="mat-checkbox" color="primary" style="margin-left: 48px;"
                                              [checked]="isCheckEmailExpire"
                                              (change)="checkSendEmailCustomerExpire()">Email</mat-checkbox>
                                          </div>
                                        </div>
                                      </div>
                                  <div>
                                    <mat-error
                                      *ngIf="isCheckEmailExpire == false && documents.isSendSmsExpireContract === false && documents.isOnNotifyExpireContract">
                                      {{'validation.selectObjectValidate' | translate}}
                                    </mat-error>
                                  </div>

                                    <!--Thời gian nhắc-->
                                    <div class="reminder-to-sign" *ngIf="documents.isOnNotifyExpireContract">
                                        <mat-form-field class="w-100">
                                            <input type="number" min="1" maxlength="9"
                                                oninput="validity.valid||(value=''); if (Number(this.value) > 100) this.value = '100'"
                                                class="input-cycle" matInput
                                                [placeholder]="'search_form.time_notify_before_expire' | translate"
                                                name="reminderTime" required (ngModelChange)="onChangeFormInput()"
                                                [(ngModel)]="documents.timeNotifyBeforeExpire" #timeNotify="ngModel">
                                            {{'search_form.day_before_expire' | translate}}
                                            <mat-error *ngIf="timeNotify.invalid">
                                                {{'validation.time_notify' | translate}}
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <!-- Chu kỳ nhắc hết hạn-->
                                    <div class="reminder-to-sign" *ngIf="documents.isOnNotifyExpireContract">
                                        <mat-form-field class="w-100">
                                            <input type="number" min="0" maxlength="9"
                                                oninput="validity.valid||(value=''); if (Number(this.value) > 30) this.value = '30'"
                                                class="input-cycle" matInput name="cycleNotify"
                                                [placeholder]="'search_form.cycle_reminder' | translate"
                                                [(ngModel)]="documents.cycleNotifyExpireContract">
                                            {{'search_form.day_time' | translate}}
                                        </mat-form-field>
                                    </div>
                                </mat-tab>
                            </mat-tab-group>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>

            </mat-card-content>
            <!--Button action-->
            <div class="col-12 mb-3" style="padding-top: 20px; text-align: center" >
                <mat-dialog-actions class="mt-2 mat-dialog-actions-custom">
                    <button mat-stroked-button color="primary" class="mr-3 mb-1 button" type="button"
                        (click)="onBtnCancelClick()"
                        >
                        <mat-icon class="mr-0">cancel</mat-icon>
                        {{'button.cancel' | translate}}
                    </button>
                    <ng-container>
<!--                      || (!(isCheckSMSInFlow && (documents.isSendCustomerInFlow || (documents.sendSMSInternalInFlow && documents.sendSMSInternalInFlow.length > 0))) && !(isCheckEmailInFlow && (checkboxSendEmailInternalInFlow(documents.notificationServiceTypes) || (getEmailConfig(documents.notificationServiceTypes)))))-->
                        <button mat-raised-button type="submit" color="primary" class="button"
                            [disabled]="((f.form.invalid || !isFormChanging || (documents.isOnAutoNumber && !listDataPreview)) ||(f.form.invalid && documents.configGeneral === 1) ||
                                  ((f.form.invalid || (isInvalidMaxMin && documents.allowOtp && isOtpLimited) || !isFormChanging
                             || !checkDisableInFlow()
                                   || !checkDisableSign()
                                   || !checkDisableExpire()
                                   || checkIsErrorRemind()
                                   || checkIsErrorProcess()
                                   || (documents.timeNotifyBeforeExpire == null && documents.isOnNotifyExpireContract)) && documents.configGeneral === 2)) || (documents && documents.customerImagesConfig && !documents.customerImagesConfig.length) || (documents.isEmploymentContract && !selectedContract)">
                            <mat-icon class="mr-0">save</mat-icon>
                            <ng-container *ngIf="!documents.id; else saveButton">
                                {{'button.add_service_type' | translate}}
                            </ng-container>
                            <ng-template #saveButton> {{'button.save' | translate}}</ng-template>
                        </button>
                    </ng-container>
                </mat-dialog-actions>
            </div>
        </mat-card-content>
    </mat-card>
</form>
